var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('router-link',{attrs:{"to":{name: _vm.route}}},[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.withSeparator)?_c('span',{staticClass:"hidden md:inline self-center"},[_vm._v(" | ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }